import { Button, CircularProgress } from '@mui/material';
import { ReactComponent as Excel } from '../../../assets/ICONS/excel.svg';
import { Download } from '@mui/icons-material';
import CustomTooltip from '../CustomTooltip';

interface ExcelDownloadButtonProps {
  isExcelDownloading: boolean;
  onDownloadCsv: any;
  tooltipTitle?: string;
}

const ExcelDownloadButton: React.FC<ExcelDownloadButtonProps> = ({
  isExcelDownloading,
  onDownloadCsv,
  tooltipTitle = 'Export current view as CSV',
}) => {
  return (
    <CustomTooltip
      title={isExcelDownloading ? 'Download in progress...' : tooltipTitle}
    >
      <Button
        className="exportButton"
        onClick={isExcelDownloading ? undefined : onDownloadCsv}
        style={{
          pointerEvents: isExcelDownloading ? 'none' : 'auto',
          opacity: isExcelDownloading ? 0.6 : 1,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            gap: '4px',
          }}
        >
          {isExcelDownloading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <>
              <Excel />
              <Download style={{ fontSize: '1.5rem' }} />
            </>
          )}
        </div>
      </Button>
    </CustomTooltip>
  );
};
export default ExcelDownloadButton;
